var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "site-footer" }, [
      _c("div", { staticClass: "text-right" }, [
        _c(
          "a",
          { attrs: { href: "http://strappberry.com/", target: "_blank" } },
          [_vm._v("Strappberry | Mobile App Development \n    ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }